export default "__VITE_ASSET__k$y26fnO__"